import { Page } from "components/Page"
import { Wrapper } from "components/Wrapper"
import { Text } from "components/Text"
import { Flag } from "components/Icon"
import { useTranslator } from "components/Translator"

export const ClubPage = ({ title, children, googleReviewsWidget = false }) => {
  return (
    <Page padded>
      <div className="space-y-6">
        <Wrapper>
          <ClubPageTitle googleReviewsWidget={googleReviewsWidget}>
            {title}
          </ClubPageTitle>
        </Wrapper>
        <div>{children}</div>
      </div>
    </Page>
  )
}

const ClubPageTitle = ({ children, googleReviewsWidget = false }) => {
  const translator = useTranslator()

  return (
    <div>
      <div className="flex items-center space-x-2">
        <Flag className="text-secondary-default w-4" />
        <Text variant="headline3" className="text-secondary-dark">
          Club
        </Text>
      </div>
      <div className="flex gap-10">
        <Text variant="headline1" tag="h1" className="text-dark">
          {children}
        </Text>
        {googleReviewsWidget ? (
          <div
            className="review-widget_net"
            data-uuid={translator.trans(
              "club.testimony.index.grwapiUuid",
              null,
              "pages",
            )}
            data-template="2"
            data-lang={translator.locale}
            data-theme="light"
          ></div>
        ) : null}
      </div>
    </div>
  )
}
